import { render, staticRenderFns } from "./PassRecord.vue?vue&type=template&id=e74158e0&scoped=true"
import script from "./PassRecord.vue?vue&type=script&lang=js"
export * from "./PassRecord.vue?vue&type=script&lang=js"
import style0 from "./PassRecord.vue?vue&type=style&index=0&id=e74158e0&prod&lang=scss"
import style1 from "./PassRecord.vue?vue&type=style&index=1&id=e74158e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e74158e0",
  null
  
)

export default component.exports